// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    debug: true,
    backend: {
      // Force refresh of locale files to avoid stale cached translations.
      loadPath: `${process.env.PUBLIC_URL || ''}/locales/{{lng}}/{{ns}}.json?v=20260211`,
    },
    detection: {
      // App uses ?language=xx in several places; keep backward compatibility with cookie.
      order: ['querystring', 'localStorage', 'cookie', 'navigator'],
      lookupQuerystring: 'language',
      cache: ['localStorage', 'cookie'],
    },
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;